<template>
    <div>
        <h6 v-if="(profileId == 0)" class="heading-small text-muted mb-4 text-truncate">Create Add On Charge {{ (this.charge.description) ? (" - " + this.charge.description) : "" }} </h6>
        <h6 v-else-if="profileId != 0 && $attrs.viewMode == true" class="heading-small text-muted mb-4 text-truncate">View Add On Charge {{ (this.charge.id) ? ("(AOC#" + this.charge.id + ")") : "" }} {{ (this.charge.description) ? (" - " + this.charge.description) : "" }}</h6>
        <h6 v-else class="heading-small text-muted mb-4 text-truncate">Edit Add On Charge {{ (this.charge.description) ? (" - " + this.charge.description) : "" }}</h6>

        <base-alert v-if="errors.length" type="danger">
            <button type="button" class="close" aria-label="Close" @click="errors = []">
              <span aria-hidden="true">&times;</span>
            </button>
            <b>You have the following error(s):</b>
            <li v-for="error in errors" :key="error">{{ error }}</li> 
        </base-alert>

    
        <div class="row mt-3">
            <div class="col-md-12">
                <a-steps :current="current" direction="horizontal" @change="onChange" progress>
                  <a-step v-for="item in steps" :key="item.title" :title="item.title"/>
                </a-steps>
            </div>

            <div class="steps-content col-md-12" >
                <!-- FORM HERE --> 
                <a-spin :spinning="spinning">
                <form id="form-proper">
                    <div v-if="customFormMode == 1 || customFormMode == 3">

                        <div v-if="current == 0" class="row" style="margin: 50px 50px 50px 50px;">
                            <div class="col-md-12">
                                <base-input label="Description" required>
                                    <a-input :disabled="viewMode" type="text" v-model="charge.description"/>
                                </base-input>

                                <base-input label="Remarks">
                                    <a-input :disabled="viewMode" type="text" v-model="charge.remarks"/>
                                </base-input>
                                <base-input label="Requesting Company">
                                    <a-auto-complete
                                        style="width: 100%"
                                        placeholder="Select a Company"
                                        :filter-option="filterOption"
                                        @select="selectCompany"
                                        :value="company.label"
                                        @search="fetchCompanies"
                                        @focus="fetchCompanies"
                                        :disabled="viewMode"
                                        :allowClear='true'>
                                        <template slot="dataSource">
                                            <a-select-option v-for="c in companies" :key="'companies'+c.id.toString()" :text="c.name">{{c.name}}</a-select-option>
                                        </template>
                                    </a-auto-complete>
                                    <i class="fas fa-info-circle"></i> <i class="small text-info" style="background-color: 'b';">Any selected documents will be reset if the requesting company is changed.</i>
                                </base-input>
                                <base-input label="Requesting Supplier">
                                    <a-auto-complete
                                        style="width: 100%"
                                        placeholder="Select a Supplier"
                                        :filter-option="filterOption"
                                        @select="selectSupplierHeader"
                                        :value="supplier.label"
                                        @search="fetchSuppliers"
                                        @focus="fetchSuppliers"
                                        :disabled="viewMode"
                                        :allowClear='true'>
                                        <template slot="dataSource">
                                            <a-select-option v-for="s in suppliers" :key="'suppliers'+s.id.toString()" :text="s.name">{{s.name}}</a-select-option>
                                        </template>
                                    </a-auto-complete>
                                    <i class="fas fa-info-circle"></i> <i class="small text-info">Any selected documents will be reset if the requesting supplier is changed.</i>
                                </base-input>
                                <!-- <base-input label="Bill To" required>
                                <a-select   showSearch
                                            v-model="charge.bill_supplier_id"
                                            style="width: 100%" placeholder="Please select"
                                            :filterOption="false"
                                            :notFoundContent="fetching ? undefined : null"
                                            :disabled="viewMode"
                                            @search="handleBillToSearch"
                                            @focus="handleBillToSearch"
                                >
                                    <a-spin v-if="fetching" slot="notFoundContent" size="small" />
                                    <a-select-option v-for="option in sup_bill" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                </a-select>
                                </base-input>

                                <base-input label="Pay To" required>
                                    <a-select   showSearch
                                                v-model="charge.pay_supplier_id"
                                                style="width: 100%" placeholder="Please select"
                                                :filterOption="false"
                                                :notFoundContent="fetching ? undefined : null"
                                                :disabled="viewMode"
                                                @search="handlePayToSearch"
                                                @focus="handlePayToSearch"
                                    >
                                        <a-spin v-if="fetching" slot="notFoundContent" size="small" />
                                        <a-select-option v-for="option in sup_pay" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                    </a-select>
                                </base-input> -->
                            </div>
                        </div>

                        <div v-if="current == 1" class="row" style="margin: 50px 50px 50px 50px;">
                            <div class="col-md-12">
                                <div class="row pb-2">
                                    <div class="col ">
                                        <h3 class="heading-md text-muted">Charge List</h3>
                                    </div>
                                    <div class="col-2 d-flex align-items-end" v-if="additionalChargeSelectedRowKeys && additionalChargeSelectedRowKeys.length > 0 && viewMode == false && charge.status == 'S'">
                                        <button type="button" v-if="charge.status == 'S'" class="btn btn-danger btn-sm btn-block align-bottom" @click="mass_delete_charge()">Remove Charge</button>
                                    </div>
                                    <div class="col-2 d-flex align-items-end">
                                        <button type="button" v-if="viewMode == false && charge.status == 'S'" class="btn btn-primary btn-sm btn-block align-bottom" @click="chargeDrawerVisible = true; bill_supplier_name = ''; pay_supplier_name = ''; currency_rate = ''; vat_type = '';">Add Charge</button>
                                    </div>
                                </div>
                                <a-table :rowSelection="additionalChargeRowSelection" rowKey='line_no' :columns="additionalChargeColumns" :dataSource="additionalChargeData" :pagination="true" size="small">
                                <span slot="amount" slot-scope="text, record">
                                    {{formatMyNumber(Number(record.amount), 2)}}
                                </span> 
                                <span slot="vat_amount" slot-scope="text, record">
                                    {{formatMyNumber(Number(record.vat_amount), 2)}}
                                </span> 
                                <template #footer>
                                    <h3>Total Amount: {{formatMyNumber(Number(totalAddOnCharge), 2)}}<br>
                                    Total VAT Amount: {{formatMyNumber(Number(totalAddOnChargeVat), 2)}}</h3>
                                </template>
                                </a-table>

                                <a-drawer
                                    :width="1200"
                                    placement="right"
                                    @close="chargeDrawerVisible = false"
                                    :visible="chargeDrawerVisible"
                                    style="z-index: 999999!important;"
                                >
                                    <h6 class="heading-small text-muted mb-4 text-truncate">Add Charge</h6>
                                    <base-alert v-if="notifMessage.length" type="danger">
                                        <b>You have the following error(s):</b>
                                        <li v-for="error in notifMessage" :key="error">{{ error }}</li>
                                    </base-alert>
                                    <form>
                                    <base-input label="Charge Type">
                                        <select class="form-control" v-model="charge_id" @change='selectChargeType()'>
                                            <option v-for="option in chargeTypeOptions" v-bind:key="'chargeTypeOptions'+option.id" v-bind:value="option.id">
                                                {{option.name}} - {{option.gl_code}}
                                            </option>
                                        </select>
                                    </base-input>
                                    <base-input label="Charge Date">
                                        <a-date-picker
                                            style="width: 100%"
                                            :value="charge_date ? moment(charge_date, 'YYYY-MM-DD') : null"
                                            format="YYYY-MM-DD"
                                            @change="onChargeDateChange"
                                            :getPopupContainer="getPopupContainer"
                                            :popupStyle="{ zIndex: 2000000 }"
                                            :disabled="viewMode"
                                        />
                                    </base-input>
                                    <base-input label="GL Code" placeholder="" v-model="gl_code" input-classes="form-control" disabled />
                                    <base-input label="Bill To">
                                        <select class="form-control" v-model="bill_supplier_id" @change='selectSupplier'>
                                            <option v-for="option in supplierOptions" v-bind:key="'supplierOptions'+option.id" v-bind:value="option.id">
                                                {{option.name}}
                                            </option>
                                        </select>
                                    </base-input>
                                    <base-input label="Vat Type" placeholder="" v-model="vat_type" input-classes="form-control" disabled />
                                    <base-input label="WTax Code" placeholder="" v-model="wtax_code" input-classes="form-control" disabled />
                                    <base-input label="Payment Term" placeholder="" v-model="payment_term" input-classes="form-control" disabled />
                                    <base-input label="Currency" placeholder="" v-model="currency" input-classes="form-control" disabled />
                                    <base-input label="Currency Rate" placeholder="" v-model="currency_rate" input-classes="form-control" disabled />
                                    <!-- <base-input label="Bill To" required>
                                        <div class="form-group row">
                                            <div class="col-sm-6">
                                                <input type="hidden" class="form-control" v-model="bill_supplier_id" disabled>
                                                <input type="text" class="form-control" v-model="bill_supplier_name" disabled>
                                            </div>
                                            <div class="col-sm-6">
                                                <autocomplete
                                                    ref="autocomplete"
                                                    placeholder="Search Supplier"
                                                    :source="supplierEndpoint"
                                                    input-class="form-control"
                                                    results-property="data"
                                                    :results-display="formattedDisplay"
                                                    :request-headers="authHeaders"
                                                    @selected="getBillSupplier">
                                                </autocomplete>
                                            </div>
                                        </div>
                                    </base-input> -->
                                    <!-- <base-input label="Pay To" required>
                                        <div class="form-group row">
                                            <div class="col-sm-6">
                                                <input type="hidden" class="form-control" v-model="pay_supplier_id" disabled>
                                                <input type="text" class="form-control" v-model="pay_supplier_name" disabled>
                                            </div>
                                            <div class="col-sm-6">
                                                <autocomplete
                                                    ref="autocomplete"
                                                    placeholder="Search Supplier"
                                                    :source="supplierEndpoint"
                                                    input-class="form-control"
                                                    results-property="data"
                                                    :results-display="formattedDisplay"
                                                    :request-headers="authHeaders"
                                                    @selected="getPaySupplier">
                                                </autocomplete>
                                            </div>
                                        </div>
                                    </base-input> -->
                                    <base-input  :label="'Amount (' + currency + ')'" placeholder="" v-model="amount" input-classes="form-control" @input='calculateVatAmount'/>
                                    <base-input :label="'Vat Amount (' + currency + ')'" :disabled="isNonVat" placeholder="" v-model="vat_amount" input-classes="form-control" />
                                    <base-input alternative="" label="Remarks / Reference">
                                        <textarea rows="4" class="form-control" v-model="charge_remarks" />
                                    </base-input>
                                    <div style="position: absolute; bottom: 0px;right: 0px; width: -webkit-fill-available; background-color: #f2f2f2 ;padding: 10px;">
                                        <button type="button" class="btn btn-primary float-right" @click='addCharge()' >Add</button>
                                        <button type="button" class="btn float-right mr-2" @click="chargeDrawerVisible = false">Close</button>
                                    </div>
                                    </form>
                                </a-drawer>
                            </div>
                        </div>

                        <div v-if="current == 2" class="row" style="margin: 50px 50px 50px 50px;">
                            <div class="col-md-12">
                                <div class="row pb-2">
                                    <div class="col ">
                                        <h3 class="heading-md text-muted">Document List</h3>
                                    </div>
                                    <div class="col-2 d-flex align-items-end" v-if="documentSelectedRowKeys && documentSelectedRowKeys.length > 0 && viewMode == false && charge.status == 'S'">
                                        <button type="button" v-if="charge.status == 'S'" class="btn btn-danger btn-sm btn-block align-bottom" @click="mass_delete_document()">Remove Document</button>
                                    </div>
                                    <!-- <div class="col-2 d-flex align-items-end">
                                        <button type="button" v-if="charge.status == 'S' && viewMode == false" class="btn btn-primary btn-sm btn-block align-bottom" @click="documentDrawerVisible = true; documentOptions.ajaxURL = endPoint+'documents/documents_for_add_on_charges?supplier_id='+charge.pay_supplier_id">Add Document</button>
                                    </div> -->
                                    <div class="col-2 d-flex align-items-end">
                                        <button type="button" v-if="charge.status == 'S' && viewMode == false" class="btn btn-primary btn-sm btn-block align-bottom" @click="documentDrawerVisible = true; documentOptions.ajaxURL = endPoint+'documents/documents_for_add_on_charges?company_id='+charge.company_id+'&supplier_id='+charge.supplier_id">Add Document</button>
                                    </div>
                                </div>
                                <a-table :rowSelection="documentRowSelection" rowKey='line_no' :columns="documentColumns" :dataSource="documentData" :pagination="true" size="small">
                                <span slot="document_amount" slot-scope="text, record">
                                    {{formatMyNumber(Number(record.document_amount), 2)}}
                                </span> 
                                <template #footer><h3>Total Document Amount: {{formatMyNumber(Number(totalDocumentsAmount), 2)}}</h3></template>
                                </a-table>

                                <a-drawer title="Click to add Suppliers Bill" wrapClassName='document-form-drawer' :width="1700" placement="right" @close="documentDrawerVisible = false" :visible="documentDrawerVisible">
                                <VueTabulator ref="tabulator" :options="documentOptions" @row-click="documentRowClick"/>
                                <div style="position: absolute; bottom: 0px;right: 0px; width: -webkit-fill-available; background-color: #f2f2f2 ;padding: 10px;">
                                    <button type="button" class="btn float-right mr-2" @click="documentDrawerVisible = false">Close</button>
                                </div>
                                </a-drawer>

                            </div>
                        </div>

                        <div v-if="current == 3" class="row" style="margin: 50px 50px 50px 50px;">
                            <div class="col-md-12">
                                <div class="row pb-1">
                                    <div class="col-8">
                                        <h3 class="heading-md text-muted">Summary</h3>
                                    </div>
                                    <!-- <div class="col-2 d-flex align-items-end">
                                        <button type="button" class="btn btn-danger btn-sm btn-block align-bottom" @click="mass_delete_charge()"><i class="fa-solid fa-file-pdf"></i> Print Summary</button>
                                    </div>
                                    <div class="col-2 d-flex align-items-end">
                                        <button type="button" class="btn btn-success btn-sm btn-block align-bottom" @click="chargeDrawerVisible = true;"><i class="fa-solid fa-file-excel"></i> Print Detailed</button>
                                    </div> -->
                                    <div class="col-12" style="margin-top: -10px; margin-bottom: 10px;">
                                        <hr>
                                    </div>
                                </div>
                                <div class="row pb-1">
                                    <div class="col-4 d-flex align-items-end">
                                        Description:
                                    </div>
                                    <!-- <div class="col-4 d-flex align-items-end">
                                        Bill To:
                                    </div> -->
                                    <div class="col-4 d-flex align-items-end">
                                        Status:
                                    </div>
                                    <div class="col-4 d-flex align-items-end">
                                        Document Amount:
                                    </div>
                                </div>
                                <div class="row pb-1">
                                    <div class="col-4 d-flex align-items-end">
                                        <h3> {{ charge.description }} </h3>
                                    </div>
                                    <!-- <div class="col-4 d-flex align-items-end">
                                        <h3> {{ sup_bill[sup_bill.findIndex(x => x.id == charge.bill_supplier_id)]['name'] }} </h3>
                                    </div> -->
                                    <div class="col-4 d-flex align-items-end">
                                        <h3> {{ (charge.status == 'S') ? 'SAVED' : 'POSTED' }} </h3>
                                    </div>
                                    <div class="col-4 d-flex align-items-end">
                                        <h3> {{ formatMyNumber(Number(totalDocumentsAmount), 2) }} </h3>
                                    </div>
                                </div>
                                <div class="row pb-1">
                                    <div class="col-4 d-flex align-items-end">
                                        Remarks:
                                    </div>
                                    <!-- <div class="col-4 d-flex align-items-end">
                                        Pay To:
                                    </div> -->
                                    <div class="col-4 d-flex align-items-end">
                                        Add On Charge Amount [PHP]:
                                    </div>
                                    <div class="col-4 d-flex align-items-end">
                                        Add On Charge VAT Amount [PHP]:
                                    </div>
                                </div>
                                <div class="row pb-1">
                                    <div class="col-4 d-flex align-items-end">
                                        <h3> {{ charge.remarks }} </h3>
                                    </div>
                                    <!-- <div class="col-4 d-flex align-items-end">
                                        <h3> {{ sup_pay[sup_pay.findIndex(x => x.id == charge.pay_supplier_id)]['name'] }} </h3>
                                    </div> -->
                                    <div class="col-4 d-flex align-items-end">
                                        <h3> {{ formatMyNumber(Number(totalAddOnCharge), 2) }} </h3>
                                    </div>
                                    <div class="col-4 d-flex align-items-end">
                                        <h3> {{ formatMyNumber(Number(totalAddOnChargeVat), 2) }} </h3>
                                    </div>
                                    <div class="col-12" style="margin-top: -10px; margin-bottom: -10px;">
                                        <hr>
                                    </div>
                                </div>   
                                <VueTabulator ref="tabulator" v-model="summaryData" :options="summaryOptions" @row-click="summaryRowClick"/>
                            </div>
                        </div>

                        <div v-if="current == 4" class="row" style="margin: 50px 50px 50px 50px;">
                            <dynamic-form :convertedJson="{mode: 'list', groups: customForm.groups_append}" :formSettings="this.charge" @valueUpdated="updateSettings" :key="dynamicFormKey" :showErrors="false"/>
                        </div>

                    </div>
                </form>
            </a-spin>
            </div>
        </div>

        <div  style="position: absolute; bottom: 0px;right: 0px; width: -webkit-fill-available; background-color: #f2f2f2 ;padding: 10px;">
            <div class="steps-action float-right">
                <button v-if="current>0" style="margin-left: 8px" @click="current--" class="btn btn-sm">
                  Previous
                </button>
                <button v-if="current < steps.length - 1" type="primary" @click="current++" class="btn btn-sm btn-primary">
                  Next
                </button>
                <button
                  class="btn btn-sm btn-primary"
                  v-if="current == steps.length - 1 && viewMode == false && charge.status == 'S' && accessRights.includes('A')"
                  type="primary"
                  @click="done(0)"
                >
                  Save
                </button>
                <a-popconfirm v-if="current == steps.length - 1 && viewMode == false && charge.status == 'S' && accessRights.includes('P') && Number(totalDocumentsAmount) > 0" title="You are about to save and post these charges, and this will recompute the cost layer based on charge distribution."
                    @confirm="done(1)" okText="Proceed" cancelText="Cancel">
                    <a class="btn btn-danger btn-sm text-white">Save & Post</a>
                </a-popconfirm>
                <button
                  class="btn btn-sm"
                  v-if="current == steps.length - 1"
                  type="primary"
                  @click="$emit('refreshPage', '')"
                >
                  Close
                </button>
            </div>
        </div>
    
    </div>

</template>

<script>

import HTTPRequest from '../../controllers/httpRequest.js'
import secureStorage from '../../controllers/secureStorage.js'
import ValidateField from '../../components/validateFormUtils.js'
import DynamicForm from '../DynamicForm.vue'
import Vuetable from "vuetable-2/src/components/Vuetable";
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import Autocomplete from 'vuejs-auto-complete'

import { mapState } from 'vuex'
import moment from 'moment';
import axios from "axios";

var component_x;

const getNotificationStyle = type => {
        return {
            success: {
                color: 'rgba(0, 0, 0, 0.65)',
                border: '1px solid #b7eb8f',
                backgroundColor: '#f6ffed'
            },
            warning: {
                color: 'rgba(0, 0, 0, 0.65)',
                border: '1px solid #ffe58f',
                backgroundColor: '#fffbe6'
            },
            error: {
                color: 'rgba(0, 0, 0, 0.65)',
                border: '1px solid #ffa39e',
                backgroundColor: '#fff1f0'
            },
            info: {
                color: 'rgba(0, 0, 0, 0.65)',
                border: '1px solid #91d5ff',
                backgroundColor: '#e6f7ff'
            }
        }[type]
    }

export default {
    components: {
            DynamicForm,
            Vuetable,
            VuetablePagination,
            Autocomplete
    },
    data() {
        return { 
            companies: [],
            company: [],
            suppliers: [],
            supplier: [],
            //charge_date: moment(new Date()),
            charge_date: '',
            isNonVat: true,
            vat_type: null,
            wtax_code: null,
            payment_term: null,
            currency: null,
            payment_term_id: null,
            currency_id: null,
            currency_rate: 0,
            party_tax_type: null,
            supplierVatType: null,
            supplier_type_id: 0,
            notifMessage: [],
            taxRate: 12,
            charge_id: 0,
            charge_name: '',
            charge_remarks: '',
            pay_supplier_id: '',
            bill_supplier_id: '',
            pay_supplier_name: '',
            bill_supplier_name: '',
            amount: 0,
            vat_amount: 0,
            gl_code: '',
            chargeDrawerVisible: false,
            documentDrawerVisible: false,
            isChargeAmountDisabled: false,
            chargeType: '',
            additionalChargeSelectedRowKeys: [],
            documentSelectedRowKeys: [],
            totalAddOnCharge: 0,
            totalAddOnChargeVat: 0,
            totalDocumentsAmount: 0,
            supplierOptions: [],
            chargeTypeOptions: [],
            additionalChargeData: [],
            documentData: [],
            summaryData: [],
            documentChargesData: [],
            additionalChargeColumns: [
                { 
                    title: 'Charge Type Id',
                    dataIndex: 'charge_id',
                },
                {
                    title: 'Charge Type',
                    dataIndex: 'charge_name',
                },
                { 
                    title: 'Date',
                    dataIndex: 'charge_date',
                },
                { 
                    title: 'Bill To',
                    dataIndex: 'bill_supplier_name',
                },
                {
                    title: 'GL Code',
                    dataIndex: 'gl_code',
                },
                {
                    title: 'VAT Type',
                    dataIndex: 'vat_type',
                },
                {
                    title: 'WTax Code',
                    dataIndex: 'wtax_code',
                },
                {
                    title: 'Payment Term',
                    dataIndex: 'payment_term',
                },
                {
                    title: 'Currency',
                    dataIndex: 'currency',
                },
                {
                    title: 'Rate',
                    dataIndex: 'currency_rate',
                },
                {
                    title: 'Remarks / Reference',
                    dataIndex: 'charge_remarks',
                },
                {
                    title: 'Amount',
                    dataIndex: 'amount',
                    scopedSlots: { customRender: 'amount' },
                    align: 'right'
                },
                {
                    title: 'Vat Amount',
                    dataIndex: 'vat_amount',
                    scopedSlots: { customRender: 'vat_amount' },
                    align: 'right'
                }
            ],
            documentColumns: [
                {
                    title: 'Document Id',
                    dataIndex: 'document_id',
                },
                {
                    title: 'Document No',
                    dataIndex: 'document_no',
                },
                {
                    title: 'Document Date',
                    dataIndex: 'document_date',
                },
                {
                    title: 'RR Ref.',
                    dataIndex: 'rr_reference',
                },
                {
                    title: 'ASN Ref.',
                    dataIndex: 'asn_reference',
                },
                {
                    title: 'PO Ref.',
                    dataIndex: 'po_reference',
                },
                {
                    title: 'PR Ref.',
                    dataIndex: 'pr_reference',
                },
                {
                    title: 'Brand',
                    dataIndex: 'brand_name',
                },
                {
                    title: 'Company',
                    dataIndex: 'company_name',
                },
                {
                    title: 'Supplier',
                    dataIndex: 'document_supplier',
                },
                {
                    title: 'Net Amount',
                    dataIndex: 'document_amount',
                    scopedSlots: { customRender: 'document_amount' },
                    align: 'right'
                }
            ],
            summaryColumns: [
                {
                    title: 'Document Id',
                    dataIndex: 'document_id',
                },
                {
                    title: 'Document No',
                    dataIndex: 'document_no',
                },
                {
                    title: 'Document Date',
                    dataIndex: 'document_date',
                },
                {
                    title: 'Site',
                    dataIndex: 'document_site',
                },
                {
                    title: 'Net Amount',
                    dataIndex: 'document_amount',
                    scopedSlots: { customRender: 'document_amount' },
                    align: 'right'
                },
                {
                    title: 'Charge Share Amount [PHP]',
                    dataIndex: 'document_share',
                    scopedSlots: { customRender: 'document_share' },
                    align: 'right'
                }
            ],
            spinning: false,
            dynamicFormKey: 0,
            viewMode: false,
            customFormMode: 1,
            customForm: {},
            charge: {
                status: 'S',
                document_charges: [],
                amount: 0,
                vat_amount: 0,
                bill_supplier_id: -1,
                pay_supplier_id: -1,
                site_id: -1
            },
            dateFormat: 'MM-DD-YYYY',
            current: 0,
            steps: [
                { title: 'Header' },
                { title: 'Add On Charges' },
                { title: 'Documents'},
                { title: 'Summary'},
            ],

            //Document List
            documentOptions: {
            ajaxURL: '',
            ajaxConfig:{
                method:"GET", 
                headers: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress")},
            },
            pagination:"remote",
            paginationDataSent:{
                "page":"page",
                "size":"per_page"
            },
            paginationSize: 10,
            layout:"fitColumns",
            //rowClick: this.documentRowClick,
            columns: [
            {
              title: 'Date',
              field: 'document_date',
              sorter: 'string',
              headerFilter:"input"
              },
              {
              title: 'Document No.',
              field: 'code_and_document_no',
              sorter: 'number',
              headerFilter:"input"
              },
              {
              title: 'RR Ref#',
              field: 'rr_reference',
              sorter: 'string',
              headerFilter:"input"
              },
              {
              title: 'ASN Ref#',
              field: 'asn_reference',
              sorter: 'string',
              headerFilter:"input"
              },
              {
              title: 'PO Ref#',
              field: 'po_reference',
              sorter: 'string',
              headerFilter:"input"
              },
              {
              title: 'PR Ref#',
              field: 'pr_reference',
              sorter: 'string',
              headerFilter:"input"
              },
              {
              title: 'Brand',
              field: 'brand_filter.label',
              sorter: 'string',
              headerFilter:"input"
              },
              {
              title: 'Company',
              field: 'company_name',
              sorter: 'string',
              headerFilter:"input"
              },
              {
              title: 'Supplier',
              field: 'supplier_id.label',
              sorter: 'string',
              headerFilter:"input"
              },
              {
              title: 'Currency',
              field: 'currency_id.label',
              sorter: 'string',
              headerFilter:"input"
              },
              {
              title: 'Net Amount',
              field: 'formatted_amount_net',
              sorter: 'string',
              headerFilter:"input"
              },
              
            ],
            },

            //Summary List
            summaryOptions: {
            paginationSize: 10,
            layout:"fitColumns",
            //rowClick: this.documentRowClick,
            columns: [
            {
              title: '#',
              field: 'line_no',
              align: 'left',
              width: '5%'
              },
              {
              title: 'Date',
              field: 'document_date',
              align: 'left',
              width: '10%'
              },
              {
              title: 'Doc Id',
              field: 'document_id',
              align: 'left',
              width: '10%'
              },
              {
              title: 'Doc No.',
              field: 'document_no',
              align: 'left',
              width: '10%'
              },
              {
              title: 'RR Ref.',
              field: 'rr_reference',
              align: 'left',
              width: '10%'
              },
              {
              title: 'ASN Ref.',
              field: 'asn_reference',
              align: 'left',
              width: '10%'
              },
              {
              title: 'PO Ref.',
              field: 'po_reference',
              align: 'left',
              width: '10%'
              },
              {
              title: 'PR Ref.',
              field: 'pr_reference',
              align: 'left',
              width: '10%'
              },  
              {
              title: 'Brand',
              field: 'brand_name',
              align: 'left',
              width: '15%'
              },
              {
              title: 'Company',
              field: 'company_name',
              align: 'left',
              width: '15%'
              },
              {
              title: 'Supplier',
              field: 'document_supplier',
              align: 'left',
              width: '15%'
              },
              {
              title: 'Net Amount',
              field: 'document_amount',
              align: 'right',
              width: '15%',
              formatter:"money", formatterParams:{
                    decimal:".",
                    thousand:",",
                    negativeSign:true,
                    precision:2,
                }
              },
              {
              title: 'Charge Share Amount [PHP]',
              field: 'document_share',
              align: 'right',
              width: '15%',
              formatter:"money", formatterParams:{
                    decimal:".",
                    thousand:",",
                    negativeSign:true,
                    precision:2,
                }
              },
            ],
            },

            // UPLOADER
            previewVisible: false,
            previewImage: '',
            fileList: [],
            imageLoaded: true,
            authHeaders: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-File", 'ip':secureStorage.getItem("ipAddress") },
            errors: [],
            dynamicFormErrors: [],
            response: [],

            // searchable select
            fetching: false,
            sup_pay: [],
            sup_bill: [],
    
            securedSync: false,
            showSensitiveInfo: false,
            accessRights: [],
        }
    },
    computed: {
        ...mapState(['endPoint', 'profileId', 'serverType', 'publicUrl']),
        additionalChargeRowSelection() {
                const { additionalChargeSelectedRowKeys } = this;
                return {
                    onChange: (additionalChargeSelectedRowKeys) => {
                        var additionalcharges = [];
                        this.additionalChargeData.forEach(function(x){
                            additionalcharges.push(x.line_no)
                        });
                        // eslint-disable-next-line
                        this.additionalChargeSelectedRowKeys = _.intersection(additionalChargeSelectedRowKeys, additionalcharges)
                    }
                }
            },
        documentRowSelection() {
                const { documentSelectedRowKeys } = this;
                return {
                    onChange: (documentSelectedRowKeys) => {
                        var documents = [];
                        this.documentData.forEach(function(x){
                            documents.push(x.line_no)
                        });
                        // eslint-disable-next-line
                        this.documentSelectedRowKeys = _.intersection(documentSelectedRowKeys, documents)
                    }
                }
            },
    },
    mounted: async function(){
        this.spinning = true;
        //Retrieve TaxRate from Global Settings
        var tax_rate_settings = await HTTPRequest.getRequest(this.endPoint + '/system_settings');
        var default_vat_rate = 12
        if (tax_rate_settings.data[0]) {
            default_vat_rate = JSON.parse(tax_rate_settings.data[0].settings_json).default_vat_rate || 12
        }

        //Retrieving and application of Document Access Rights
        var system_module = await HTTPRequest.getRequest(this.endPoint+'/system_modules?status=A&code=AOC', null)
        var accessRightsRequest = await HTTPRequest.getRequest(this.endPoint + 'users/' + secureStorage.getItem("userId") + "/access_rights?system_module_id=" + system_module[0].id, null)

        if (accessRightsRequest.access_rights[system_module[0].id]) {
            this.accessRights  = accessRightsRequest.access_rights[system_module[0].id];
        } else {
            this.accessRights = [];
        }

        //Get supplier type for pay to
        var supplier_type = await HTTPRequest.getRequest(this.endPoint + "supplier_types?code=OTHCHR" , null, null)
        this.supplier_type_id = (supplier_type['data'].length > 0) ? supplier_type['data'][0]['id'] : 0;

        this.taxRate = Number(default_vat_rate) / 100

        this.viewMode = this.serverType == 'branch' || this.$attrs.viewMode == true;

        component_x = this

        this.securedSync = false

        const sytemModule = await HTTPRequest.getRequest(this.endPoint + 'system_modules/Add On Charge?field_name=name'  , null)
        const sytemModuleId = sytemModule.id
        const accSystemModuleRequest = await HTTPRequest.getRequest(this.endPoint + 'account_system_modules/' + sytemModuleId + '?field_name=system_module_id'  , null)

        if(this.isJsonString(accSystemModuleRequest.meta) == true){

            const accSystemModule = JSON.parse(accSystemModuleRequest.meta)
            if(accSystemModule != null){
                if(accSystemModule.form_mode != undefined){
                    this.customFormMode = accSystemModule.form_mode
                }

                if(this.customFormMode == 4){
                    this.steps.push({title: "Custom Fields"})
                }

                if(accSystemModule.customized_forms != undefined){
                    this.customForm = accSystemModule.customized_forms
                }
            }
        }

        //Get Charge Types
        var chargetypes = await HTTPRequest.getRequest(this.endPoint + "charges" , null, null)
        this.chargeTypeOptions = chargetypes.data;
        this.chargeTypeOptions.sort((a, b) => {
        const nameA = a.name.toUpperCase(); // ignore upper and lowercase
        const nameB = b.name.toUpperCase(); // ignore upper and lowercase
        if (nameA < nameB) {
            return -1;
        }
        if (nameA > nameB) {
            return 1;
        }
        // names must be equal
        return 0;
        });
       

        //Get Suppliers
        var suppliers = await HTTPRequest.getRequest(this.endPoint + "suppliers?per_page=500" , null, null)
        this.supplierOptions = suppliers.data;
        if(suppliers.last_page > 1){
            for (let i = 1; i < suppliers.last_page; i++) {
                var page = i+1;
                var suppliers = await HTTPRequest.getRequest(this.endPoint + "suppliers?per_page=500&page="+page , null, null)
                this.supplierOptions.push(...suppliers.data);
            }
        } 
        
        this.supplierOptions.sort((a, b) => {
        const nameA = a.name.toUpperCase(); // ignore upper and lowercase
        const nameB = b.name.toUpperCase(); // ignore upper and lowercase
        if (nameA < nameB) {
            return -1;
        }
        if (nameA > nameB) {
            return 1;
        }
        // names must be equal
        return 0;
        });

        if (this.profileId > 0) {
                var charge_data = await HTTPRequest.getRequest(component_x.endPoint + 'add_on_charges/' + this.profileId, null)
                this.chargeData = charge_data
                if (charge_data == undefined) {
                    component_x.$router.go()
                } else {
                    if (charge_data["error"] == undefined) {
                        this.charge = charge_data
                        delete this.charge.extras
                        this.additionalChargeData = charge_data.document_charges[0]['additionalChargeData']
                        this.documentData = charge_data.document_charges[0]['documentData']
                        this.summaryData = charge_data.document_charges[0]['summaryData']
                        this.totalCharge();
                        this.totalDocument();

                        if(Number(charge_data['company_id']) > 0 && Number(charge_data['supplier_id']) > 0){
                            var company_details = await HTTPRequest.getRequest(component_x.endPoint + 'companies/' + Number(charge_data['company_id']), null)
                            this.company = {
                                key:charge_data['company_id'],
                                label: company_details['name']
                            }

                            var supplier_details = await HTTPRequest.getRequest(component_x.endPoint + 'suppliers/' + Number(charge_data['supplier_id']), null)
                            this.supplier = {
                                key:charge_data['supplier_id'],
                                label: supplier_details['name']
                            }
                        }

                    } else {
                        this.errors = charge_data["error"].split(",");
                    }
                }
            }
            
        this.dynamicFormKey++;
        this.spinning = false;
    },
    watch: {
        party_tax_type: function() {
                switch (this.party_tax_type) {
                    case "V":
                        this.vat_type = "Vatable"
                    break;
                    case "X":
                        this.vat_type = "Vat-Exempt"
                    break;
                    case "Z":
                        this.vat_type = "Zero-Rated"
                    break;
                    default:
                    break;
                }
            },
        // current: async function(){
        //     if (!this.showSensitiveInfo) {
        //         this.charge_data.identification = {type: "1"}
        //     }
        // },
        // is_active: function() {
        //     if(this.is_active == false){
        //         this.charge.status = 'I'
        //     } else {
        //         this.charge.status = 'A'
        //     }
        // },
        
    },
    methods: {
        async fetchCompanies(value){
                this.company = {key: '', label: value}
                this.fetching = true
                if (value == undefined) value = ''
                this.companies = await HTTPRequest.getRequest(this.endPoint + 'companies/get_valid_companies?name='+value, null)
                this.fetching = false
        },
        selectCompany (company, option){
                company = company.replace('companies','')
                var arr = {
                    key:company,
                    label: option.data.attrs.text
                }
                company = arr
                Object.assign(this, {
                    company,
                    companies: [],
                    fetching: false,
                })

                var company_id = null
                if(this.company.key != null && this.company.key != ""  && this.company.key != []){
                    this.charge.company_id = this.company.key
                }
                this.documentData = []
                this.summaryData = []
        },
        async fetchSuppliers(value){
                this.supplier = {key: '', label: value}
                this.fetching = true
                if (value == undefined) value = ''
                this.suppliers = await HTTPRequest.getRequest(this.endPoint + 'suppliers/get_valid_suppliers?name='+value, null)
                this.fetching = false
        },
        selectSupplierHeader (supplier, option){
                supplier = supplier.replace('suppliers','')
                var arr = {
                    key:supplier,
                    label: option.data.attrs.text
                }
                supplier = arr
                Object.assign(this, {
                    supplier,
                    suppliers: [],
                    fetching: false,
                })

                var supplier_id = null
                if(this.supplier.key != null && this.supplier.key != ""  && this.supplier.key != []){
                    this.charge.supplier_id = this.supplier.key
                }
                this.documentData = []
                this.summaryData = []
        },
        moment,
        supplierEndpoint (input) {
            return this.endPoint + '/suppliers?name=' + input;
        },
        getPaySupplier (group) {
            this.pay_supplier_name = group.display;
            this.pay_supplier_id = group.value;
        },
        async getBillSupplier (group) {
            this.bill_supplier_name = group.display;
            this.bill_supplier_id = group.value;
        },
        formattedDisplay (result) {
          return result.name + ' [' + result.code + ']';
        },
        selectChargeType() {
            for (var j = 0; j < this.chargeTypeOptions.length; j++){
                if(this.charge_id == this.chargeTypeOptions[j]['id']) {
                    this.gl_code = this.chargeTypeOptions[j]['gl_code']
                    this.charge_name = this.chargeTypeOptions[j]['name']
                    break;
                }
            }
        },
        async selectSupplier() {
            if(!this.isValidDate(this.charge_date)){
                alert('Invalid charge date format, it should be "YYYY-MM-DD"')
                this.charge_date = ''
                return
            }
            var supplier_details = this.supplierOptions.find(o => o.id === this.bill_supplier_id);
            this.party_tax_type = supplier_details.vat_type
            this.wtax_code = supplier_details.wtax_code
            this.payment_term = supplier_details.payment_term_name
            this.payment_term_id = supplier_details.payment_term_id
            this.currency = supplier_details.currency_name
            this.currency_id = supplier_details.currency_id
            this.bill_supplier_name = supplier_details.name

            if(supplier_details.currency_id > 0){
                this.supplierCurrencyId = supplier_details.currency_id
                var currency_histories = await this.getSupplierCurrencyByDocDate(this.supplierCurrencyId)
                if (currency_histories.length > 0) {
                    this.currency_rate = currency_histories[0].conversion_rate || supplier_details.currency_rate
                } else {
                    this.currency_rate = supplier_details.currency_rate
                }
            } else {
                this.currency_rate = 1
            }

            if(supplier_details.vat_type == 'V'){
                this.isNonVat = false
                this.calculateVatAmount()
            }else{
                this.isNonVat = true
                this.vat_amount = 0
            }
        },
        async getSupplierCurrencyByDocDate(currency_id){
                // var currency_details = await HTTPRequest.getRequest(this.endPoint + 'currencies/get_currency_by_document_date?currency_id='+currency_id+'&business_date='+this.charge_date.format('YYYY-MM-DD'), null)
                if(this.isValidDate(this.charge_date)){
                    var currency_details = await HTTPRequest.getRequest(this.endPoint + 'currencies/get_currency_by_document_date?currency_id='+currency_id+'&business_date='+this.charge_date, null)
                    return currency_details
                } else {
                    alert('Invalid charge date format, it should be "YYYY-MM-DD"')
                    this.charge_date = ''
                }
        },
        onChargeDateChange(date, dateString) {
            this.charge_date = dateString || '';
            if (this.charge_date) this.selectSupplier();
        },
        getPopupContainer(trigger) {
            try {
                return (document && document.body) ? document.body : document.getElementsByTagName('body')[0];
            } catch (e) {
                return document.body;
            }
        },
        isValidDate(dateString) {
            const regex = /^\d{4}-\d{2}-\d{2}$/;
            if (!regex.test(dateString)) return false;
            const date = new Date(dateString);
            const [year, month, day] = dateString.split('-').map(Number);
            return date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day;
        },
        addCharge: async function() {
                if(!this.validateCharge()) {
                    var charges = this.additionalChargeData.map(a => a.line_no);
                    var additional_charges = this.additionalChargeData.map(a => a.line_no);
                    if (charges.length == 0) charges = [0]
                    if (additional_charges.length == 0) additional_charges = [0]
                    this.additionalChargeData.push({
                        line_no: Math.max(...additional_charges) + 1,
                        charge_id: this.charge_id,
                        charge_name: this.charge_name,
                        charge_date: this.charge_date,
                        gl_code: this.gl_code,
                        amount: this.amount,
                        vat_amount: this.vat_amount,
                        charge_remarks: this.charge_remarks,
                        pay_supplier_id: this.pay_supplier_id,
                        bill_supplier_id: this.bill_supplier_id,
                        pay_supplier_name: this.pay_supplier_name,
                        bill_supplier_name: this.bill_supplier_name,
                        vat_type: this.vat_type,
                        wtax_code: this.wtax_code,
                        payment_term: this.payment_term,
                        payment_term_id: this.payment_term_id,
                        currency: this.currency,
                        currency_id: this.currency_id,
                        currency_rate: this.currency_rate
                    })
                    this.chargeDrawerVisible = false;
                    this.charge_id = '';
                    this.charge_name = '';
                    this.gl_code = '';
                    this.amount = '';
                    this.vat_amount = '';
                    this.charge_remarks = '';
                    this.pay_supplier_id = '';
                    this.bill_supplier_id = '';
                    this.pay_supplier_name = '';
                    this.bill_supplier_name = '';
                    this.party_tax_type = '',
                    this.wtax_code = '';
                    this.payment_term = '';
                    this.currency = '';
                    this.payment_term_id = '';
                    this.currency_id = '';
                    this.totalCharge();
                    this.documentActionNotification('add charge', 'success')
                } else {
                    // this.documentActionNotification('add charge', 'error')
                }
            },
        documentRowClick(e, row) {
            var documents = this.documentData.map(a => a.line_no);
            if (documents.length == 0) documents = [0]
    
            this.documentData.push({
                line_no: Math.max(...documents) + 1,
                document_id: row._row.data.id,
                document_no: row._row.data.code_and_document_no,
                pr_reference: row._row.data.pr_reference,
                po_reference: row._row.data.po_reference,
                asn_reference: row._row.data.asn_reference,
                rr_reference: row._row.data.rr_reference,
                brand_name: row._row.data.brand_filter.label,
                document_date: row._row.data.document_date,
                company_name: row._row.data.company_name,
                document_supplier: row._row.data.supplier_id.label,
                document_amount: (row._row.data.formatted_amount_net).replace(/,/g, ""),
                site_id: row._row.data.site_id.key
            })

            const key = 'document_id';
            this.documentData = [...new Map(this.documentData.map(item =>
            [item[key], item])).values()];

            //this.documentData = [...new Set(this.documentData.map(item => item.document_id))];
            this.totalDocument();
        },
        async summaryRowClick(e, row){
            //Get document lines
            var document_lines = await HTTPRequest.getRequest(this.endPoint + "document_lines/" + row._row.data.document_id + "?field_name=document_id", null, null)
            console.log(document_lines)
        },
        mass_delete_charge() {
                const newData = [...this.additionalChargeData]
                var ids = this.additionalChargeSelectedRowKeys
                var afterDelete = _.remove(newData, function(n) {
                    return !ids.includes(n.line_no);
                });
                this.additionalChargeData = afterDelete
                this.additionalChargeSelectedRowKeys = []
                this.totalCharge();
            },
        mass_delete_document() {
                const newData = [...this.documentData]
                var ids = this.documentSelectedRowKeys
                var afterDelete = _.remove(newData, function(n) {
                    return !ids.includes(n.line_no);
                });
                this.documentData = afterDelete
                this.documentSelectedRowKeys = []
                this.totalDocument();
        },
        totalCharge() {
                let i = 0;
                this.totalAddOnCharge = 0
                this.totalAddOnChargeVat = 0
                while (i < this.additionalChargeData.length) {
                    // this.totalAddOnCharge =  Number(this.totalAddOnCharge) + Number(this.additionalChargeData[i]['amount'] * this.additionalChargeData[i]['currency_rate']);
                    // this.totalAddOnChargeVat =  Number(this.totalAddOnChargeVat) + Number(this.additionalChargeData[i]['vat_amount'] * this.additionalChargeData[i]['currency_rate']);
                    var currency_rate = (Number(this.additionalChargeData[i]['currency_rate']) == 0) ? 1 : Number(this.additionalChargeData[i]['currency_rate'])
                    this.totalAddOnCharge =  Number(this.totalAddOnCharge) + Number(this.additionalChargeData[i]['amount'] * currency_rate);
                    this.totalAddOnChargeVat =  Number(this.totalAddOnChargeVat) + Number(this.additionalChargeData[i]['vat_amount'] * currency_rate);
                    i++;
                }  
                this.recomputeSummary();
            },
        totalDocument() {
                let i = 0;
                this.totalDocumentsAmount = 0
                while (i < this.documentData.length) {
                    this.totalDocumentsAmount =  Number(this.totalDocumentsAmount) + Number(this.documentData[i]['document_amount'].replace(',',''));
                    i++;
                }  
                this.recomputeSummary();
        },
        recomputeSummary() {
                this.summaryData =[]
                this.documentChargesData =[]
                let i = 0;
                let j = 0;
                let total_amount = 0
                let total_vat_amount = 0
                let document_total_amount = 0
                let document_total_vat_amount = 0
                let share = 0
                let vat_share = 0
                let document_share = 0
                let document_vat_share = 0
                while (i < this.documentData.length) {
                    j = 0;
                    document_total_amount = 0;
                    document_total_vat_amount = 0;
                    if(i+1 == this.documentData.length){
                        //Include VAT in share distribution
                        // share = (Number(this.totalAddOnCharge + this.totalAddOnChargeVat) - Number(total_amount)).toFixed(2)
                        share = (Number(this.totalAddOnCharge) - Number(total_amount)).toFixed(4)
                        vat_share = (Number(this.totalAddOnChargeVat) - Number(total_vat_amount)).toFixed(4)
                    } else {
                        //Include VAT in share distribution
                        //share = ((Number(this.documentData[i]['document_amount']) / Number(this.totalDocumentsAmount)) * Number(this.totalAddOnCharge + this.totalAddOnChargeVat)).toFixed(2)
                        share = ((Number(this.documentData[i]['document_amount']) / Number(this.totalDocumentsAmount)) * Number(this.totalAddOnCharge)).toFixed(4)
                        vat_share = ((Number(this.documentData[i]['document_amount']) / Number(this.totalDocumentsAmount)) * Number(this.totalAddOnChargeVat)).toFixed(4)
                        total_amount = Number(total_amount) + Number(share)
                        total_vat_amount = Number(total_vat_amount) + Number(vat_share)
                    }
                    
                    this.summaryData.push({
                        line_no: this.documentData[i]['line_no'],
                        document_id: this.documentData[i]['document_id'],
                        document_no: this.documentData[i]['document_no'],
                        document_date: this.documentData[i]['document_date'],
                        document_site: this.documentData[i]['document_site'],
                        document_supplier: this.documentData[i]['document_supplier'],
                        company_name: this.documentData[i]['company_name'],
                        brand_name: this.documentData[i]['brand_name'],
                        asn_reference: this.documentData[i]['asn_reference'],
                        pr_reference: this.documentData[i]['pr_reference'],
                        po_reference: this.documentData[i]['po_reference'],
                        rr_reference: this.documentData[i]['rr_reference'],
                        document_amount: this.documentData[i]['document_amount'],
                        document_share: share
                    })

                    while (j < this.additionalChargeData.length) {
                        if(j+1 == this.additionalChargeData.length){
                            document_share = (Number(share) - Number(document_total_amount)).toFixed(4)
                            if (Number(vat_share) > 0)
                                document_vat_share = (Number(vat_share) - Number(document_total_vat_amount)).toFixed(4)
                            else
                                document_vat_share = 0
                        } else {
                            //consider currency_rate in sharing
                            var document_share_with_rate = ((Number(this.additionalChargeData[j]['amount'] * this.additionalChargeData[j]['currency_rate']) / Number(this.totalAddOnCharge)) * Number(share)).toFixed(4)
                            //document_share = ((Number(this.additionalChargeData[j]['amount']) / Number(this.totalAddOnCharge)) * Number(share)).toFixed(4)
                            document_share = document_share_with_rate
                            document_total_amount = Number(document_total_amount) + Number(document_share_with_rate)
                            if (Number(vat_share) > 0)
                                document_vat_share = ((Number(this.additionalChargeData[j]['vat_amount']) / Number(this.totalAddOnChargeVat)) * Number(vat_share)).toFixed(4)
                            else
                                document_vat_share = 0
                            document_total_vat_amount = Number(document_total_vat_amount) + Number(document_vat_share)
                        }
                        this.documentChargesData.push({
                            document_id: this.documentData[i]['document_id'],
                            site_id: this.documentData[i]['document_site_id'],
                            //line_no: j + 1,
                            line_no: this.additionalChargeData[j]['line_no'],
                            name: this.additionalChargeData[j]['charge_name'],
                            amount: document_share,
                            remark: this.additionalChargeData[j]['charge_remarks'],
                            status: "A",
                            add_on_charge_id: this.profileId,
                            vat_amount: document_vat_share || 0,
                            charge_id: this.additionalChargeData[j]['charge_id'],
                            gl_code: this.additionalChargeData[j]['gl_code'],
                            pay_to: this.additionalChargeData[j]['pay_supplier_id'],
                            bill_to: this.additionalChargeData[j]['bill_supplier_id'],
                            charge_date: this.additionalChargeData[j]['charge_date'],
                            // pay_supplier_name: this.this.additionalChargeData[j]['pay_supplier_name'],
                            // bill_supplier_name: this.this.additionalChargeData[j]['bill_supplier_name'],
                            account_id: secureStorage.getItem("accountId")
                        })

                        j++;
                    }
                    i++;
                    
                } 
        },
        validateCharge(){
                this.notifMessage = []; 
                this.notifMessage.push(ValidateField.required('Charge Type', this.charge_id));
                this.notifMessage.push(ValidateField.required('Charge Date', this.charge_date));
                // this.notifMessage.push(ValidateField.required('Pay To', this.pay_supplier_id));
                this.notifMessage.push(ValidateField.required('Bill To', this.bill_supplier_id));
                this.notifMessage.push(ValidateField.decimalFormat('Amount', this.amount));
                this.notifMessage.push(ValidateField.greaterThanZero('Currency Rate', this.currency_rate));
                // this.notifMessage.push(ValidateField.decimalFormat('VAT Amount', this.vat_amount));
                // this.notifMessage.push(ValidateField.greaterThanZero('VAT Amount', this.vat_amount));
                this.notifMessage = this._.compact(this.notifMessage);
                return this.notifMessage.length;
            },
        documentActionNotification(action, type) {
                if (type == 'success') {
                    this.$notification[type]({
                        message: _.startCase(action) + ' action success',
                        style: getNotificationStyle(type),
                    });
                } else if (type == 'error') {
                    this.$notification[type]({
                        message: _.startCase(action) + ' action failed',
                        style: {
                            'z-index': 9999,
                        },
                        // eslint-disable-next-line
                        description: h => {
                            return <ul class='m-0 p-0'>
                                {this.notifMessage.map((value, index) => {
                                    return <li key={index}>{value}</li>
                                })}
                            </ul>
                        },
                        style: getNotificationStyle(type)
                    });
                }
            },
        calculateVatAmount() {
            if(this.isNonVat == false){
                this.notifMessage = [];
                this.notifMessage.push(ValidateField.decimalFormat('Amount', this.amount));
                this.notifMessage = this._.compact(this.notifMessage);
                if (this.notifMessage.length == 0) {
                    this.vat_amount = Number((this.amount * (1+Number(this.taxRate))) - this.amount).toFixed(4)
                }
            } else {
                this.vat_amount = 0
            }
        },
        done(todo){
            this.viewMode = true
            if(this.profileId > 0){
               this.update(todo)
            } else {
                this.create(todo)
            }
        },
        isJsonString(str) {
            try {
                var json = JSON.parse(str);
                return (typeof json === 'object');
            } catch (e) {
                return false;
            }
        },
        onChange(current) {
          this.current = current;
        },
        formatMyNumber(number, decimal) {
            var splitNum;
            number = Math.abs(number);
            number = number.toFixed(decimal);
            splitNum = number.split('.');
            splitNum[0] = splitNum[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            return splitNum.join(".");
        },
        validateForm(){
                this.errors = [];
                this.errors.push(ValidateField.required('Description', this.charge.description));
                // this.errors.push(ValidateField.required('Bill To', this.charge.bill_supplier_id));
                // this.errors.push(ValidateField.required('Pay To', this.charge.pay_supplier_id));
                this.errors.push(ValidateField.decimalFormat('Add On Charge Amount', this.totalAddOnCharge));
                //this.errors.push(ValidateField.greaterThanZero('Add On Charge Amount', this.totalAddOnCharge));
                this.errors.push(ValidateField.decimalFormat('Document Amount', this.totalDocumentsAmount));
                //this.errors.push(ValidateField.greaterThanZero('Document Amount', this.totalDocumentsAmount));
                this.errors = this._.compact(this.errors);
                document.getElementsByClassName('ant-drawer-wrapper-body')[0].scrollTop = 0;
                return this.errors.length;
            },

        async handlePayToSearch(value){
            this.fetching = true;
            // if(value == undefined)
            //     this.sup_pay = await HTTPRequest.getRequest(this.endPoint + "suppliers?supplier_type_id=" + this.supplier_type_id , null, null)
            // else
            //     this.sup_pay = await HTTPRequest.getRequest(this.endPoint + "suppliers?name=" + value + "&supplier_type_id=" + this.supplier_type_id, null, null)

            if(value == undefined)
                this.sup_pay = await HTTPRequest.getRequest(this.endPoint + "suppliers", null, null)
            else
                this.sup_pay = await HTTPRequest.getRequest(this.endPoint + "suppliers?name=" + value, null, null)

            this.sup_pay = this.sup_pay.data
            this.fetching = false;
        },
        async handleBillToSearch(value){
            this.fetching = true;
            if(value == undefined)
                this.sup_bill = await HTTPRequest.getRequest(this.endPoint + "suppliers" , null, null)
            else
                this.sup_bill = await HTTPRequest.getRequest(this.endPoint + "suppliers?name=" + value , null, null)

            this.sup_bill = this.sup_bill.data
            this.fetching = false;
        },
        filterOption(input, option) {
            return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
        },
        sort(data){
            data.sort(function (a, b) {
                return a.name.localeCompare(b.name);
            });
        },
        update: async function (todo, id = 0) {
            if(!this.validateForm() && this.dynamicFormErrors.length == 0) {
                this.viewMode = true
                this.spinning = true;
                this.charge.document_charges = []
                this.charge.document_charges.push({
                    "summaryData": this.summaryData, 
                    "additionalChargeData": this.additionalChargeData, 
                    "documentData": this.documentData,
                    "documentChargesData": this.documentChargesData})
                this.charge.document_amount = this.totalDocumentsAmount
                this.charge.amount = this.totalAddOnCharge
                //this.charge.vat_amount =  Number((this.totalAddOnCharge * (1+Number(this.taxRate))) - this.totalAddOnCharge).toFixed(2)
                this.charge.vat_amount = this.totalAddOnChargeVat
                var chargePayload = { charge: this.charge, todo: todo }
                var put_request = await HTTPRequest.putRequest(this.endPoint + 'add_on_charges/' + ((id > 0) ? id : this.profileId), null, chargePayload)
                if (put_request == undefined) {
                    this.$emit('refreshPage', event)
                } else {
                    if (put_request["error"] == undefined) {
                        this.$emit('refreshPage', event)
                    } else {
                        this.errors = put_request["error"].split(",")
                    }
                }
                this.spinning = false;
            } else {
                this.errors = this.dynamicFormErrors
            }
            this.viewMode = false
        },
        create: async function (todo) {
            if(!this.validateForm()) {
                this.spinning = true;
                this.charge.document_charges = []
                this.charge.document_charges.push({
                    "summaryData": this.summaryData, 
                    "additionalChargeData": this.additionalChargeData, 
                    "documentData": this.documentData,
                    "documentChargesData": this.documentChargesData})
                this.charge.document_amount = this.totalDocumentsAmount
                this.charge.amount = this.totalAddOnCharge
                //this.charge.vat_amount =  Number((this.totalAddOnCharge * (1+Number(this.taxRate))) - this.totalAddOnCharge).toFixed(2)
                this.charge.vat_amount = this.totalAddOnChargeVat
                var chargePayload = { charge: this.charge, todo: todo}
                var post_request = await HTTPRequest.postRequest(this.endPoint + 'add_on_charges', null, chargePayload)
                if (post_request == undefined) {
                    this.$emit('refreshPage', event)
                } else {
                    if (post_request["error"] == undefined) {
                        if(todo == 1){
                            this.profileId = post_request['id']
                            this.update(todo, post_request['id']);
                        } else {
                            this.$emit('refreshPage', event)
                        }
                    } else {
                        this.errors = post_request["error"].split(",")
                    }
                }
                this.spinning = false;
            }
            this.viewMode = false
        },
        updateSettings(newFormSettings, settingsGrouping, errors){
          var formSettingsCopy = this.charge
          var mergedHash = Object.assign({}, formSettingsCopy, newFormSettings);
          this.formErrors = errors

          if(this.customFormMode == 3) {
              this.dynamicFormErrors = errors
              this.errors = errors
          }
          this.charge = mergedHash

        },

    }

}
</script>

<style lang='scss'>
@import "~vue-tabulator/dist/scss/bootstrap/tabulator_bootstrap";
</style>
